import { ExternalLink, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import type { Citation } from '@shared/types'

function domain(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}
// xAI search citations often carry a numeric "title" (the index) — show the domain instead.
function label(c: Citation): string {
  const t = (c.title ?? '').trim()
  return t && !/^\d+$/.test(t) ? t : domain(c.url)
}

export function Citations({ citations }: { citations: Citation[] }) {
  // Collapsed by default — a long source list (often 80+ chips) would otherwise bury
  // the answer. Click to expand.
  const [open, setOpen] = useState(false)
  if (!citations.length) return null
  return (
    <div className="mt-3 border-t border-[var(--line-soft)] pt-2.5">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 text-[10px] uppercase tracking-[0.12em] text-fg-faint transition-colors hover:text-fg-subtle"
      >
        <ChevronRight size={11} className={`transition-transform ${open ? 'rotate-90' : ''}`} />
        Sources · {citations.length}
      </button>
      {open && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          {citations.map((c, i) => (
            <a
              key={`${c.url}-${i}`}
              href={c.url}
              target="_blank"
              rel="noreferrer noopener"
              title={label(c)}
              className="inline-flex items-center gap-1.5 rounded-md border border-[var(--line-soft)] bg-[var(--color-surface-2)] px-2 py-1 text-[11px] text-fg-subtle transition-colors hover:border-[var(--line)] hover:text-fg"
            >
              <span className="num text-fg-faint">{i + 1}</span>
              <span className="max-w-[170px] truncate">{label(c)}</span>
              <ExternalLink size={10} className="shrink-0 opacity-60" />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
